<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UiPageHeader from '@/components/ui/UiPageHeader.vue';
import PageTabs from '@/components/Utils/PageTabs.vue';
import RolesPanel from './RolesPanel.vue';
import PagesList from './PagesList.vue';

// Module management: roles and their sidebar menus, plus the catalog of
// pages they're built from (tab kept in ?tab=).
const props = defineProps({
  defaultTab: { type: String, default: 'roles' },
});

const TABS = [
  { id: 'roles', name: 'Roles & menus' },
  { id: 'pages', name: 'Pages' },
];

const route = useRoute();
const router = useRouter();
const tab = computed({
  get: () => (['roles', 'pages'].includes(route.query.tab) ? route.query.tab : props.defaultTab),
  set: (value) => router.replace({ query: { tab: value } }),
});
</script>

<template>
  <div class="page-stack">
    <UiPageHeader title="Module management" subtitle="Decide which pages each role sees in its sidebar.">
      <template #actions>
        <PageTabs v-model="tab" :items="TABS" />
      </template>
    </UiPageHeader>

    <RolesPanel v-if="tab === 'roles'" />
    <PagesList v-else />
  </div>
</template>
